import { gql } from "@apollo/client";

export const DOMAIN_FIELDS = gql`
  fragment LinkShortenerDomainFields on LinkShortenerDomain {
    __typename
    id
    createdAt
    updatedAt
    domain
    fallbackUrl
    forAllSubaccounts
    nameservers
    status
    statusMessage
    assignedSubaccounts {
      id
      deletedAt
      subaccount {
        id
        name
        slug
      }
    }
  }
`;

export const DOMAIN_REQUEST_FIELDS = gql`
  fragment LinkShortenerDomainRequestFields on LinkShortenerDomainRequest {
    __typename
    id
    createdAt
    createdBy {
      id
      fullName
    }
    domain
    fallbackUrl
    requestType
    forAllSubaccounts
    assignedSubaccountIds
  }
`;

export const LIST_DOMAINS = gql`
  ${DOMAIN_FIELDS}
  query listLinkShortenerDomains($input: ListLinkShortenerDomainsInput!) {
    listLinkShortenerDomains(input: $input) {
      records {
        ...LinkShortenerDomainFields
      }
      totalCount
    }
  }
`;

export const LIST_DOMAINS_AND_REQUESTS = gql`
  ${DOMAIN_FIELDS}
  ${DOMAIN_REQUEST_FIELDS}
  query listLinkShortenerDomainsAndRequests(
    $input: ListLinkShortenerDomainsAndRequestsInput!
  ) {
    listLinkShortenerDomainsAndRequests(input: $input) {
      records {
        ...LinkShortenerDomainFields
        ...LinkShortenerDomainRequestFields
      }
      totalCount
    }
  }
`;

export const GET_DOMAIN_DETAIL = gql`
  ${DOMAIN_FIELDS}
  query getLinkShortenerDomain($input: GetLinkShortenerDomainInput!) {
    getLinkShortenerDomain(input: $input) {
      ...LinkShortenerDomainFields
      healthCheckErrors
    }
  }
`;

export const CREATE_LINK_SHORTENER_DOMAIN = gql`
  ${DOMAIN_FIELDS}
  mutation createLinkShortenerDomain($input: CreateLinkShortenerDomainInput!) {
    createLinkShortenerDomain(input: $input) {
      ...LinkShortenerDomainFields
    }
  }
`;

export const VERIFY_LINK_SHORTENER_DOMAIN_DNS_AND_COMPLETE_SETUP = gql`
  ${DOMAIN_FIELDS}
  mutation verifyLinkShortenerDomainDNSAndCompleteSetup(
    $input: VerifyLinkShortenerDomainDNSAndCompleteSetupInput!
  ) {
    verifyLinkShortenerDomainDNSAndCompleteSetup(input: $input) {
      ...LinkShortenerDomainFields
    }
  }
`;

export const RETRY_DOMAIN_FINAL_LINK_TEST = gql`
  ${DOMAIN_FIELDS}
  mutation retryDomainFinalLinkTest($input: RetryDomainFinalLinkTestInput!) {
    retryDomainFinalLinkTest(input: $input) {
      ...LinkShortenerDomainFields
    }
  }
`;

export const UPDATE_SUBACCOUNT_SCOPING = gql`
  ${DOMAIN_FIELDS}
  mutation updateSubaccountScoping($input: UpdateSubaccountScopingInput!) {
    updateSubaccountScoping(input: $input) {
      ...LinkShortenerDomainFields
    }
  }
`;

export const UPDATE_LINK_SHORTENER_DOMAIN = gql`
  ${DOMAIN_FIELDS}
  mutation updateLinkShortenerDomain($input: UpdateLinkShortenerDomainInput!) {
    updateLinkShortenerDomain(input: $input) {
      ...LinkShortenerDomainFields
    }
  }
`;

export const ARCHIVE_LINK_SHORTENER_DOMAIN = gql`
  ${DOMAIN_FIELDS}
  mutation archiveLinkShortenerDomain(
    $input: ArchiveLinkShortenerDomainInput!
  ) {
    archiveLinkShortenerDomain(input: $input) {
      ...LinkShortenerDomainFields
    }
  }
`;

export const UNARCHIVE_LINK_SHORTENER_DOMAIN = gql`
  ${DOMAIN_FIELDS}
  mutation unarchiveLinkShortenerDomain(
    $input: UnarchiveLinkShortenerDomainInput!
  ) {
    unarchiveLinkShortenerDomain(input: $input) {
      ...LinkShortenerDomainFields
    }
  }
`;

export const CHECK_LINK_SHORTENER_DOMAIN_AVAILABILITY = gql`
  query checkLinkShortenerDomainNameAvailability(
    $input: CheckLinkShortenerDomainNameAvailabilityInput!
  ) {
    checkLinkShortenerDomainNameAvailability(input: $input)
  }
`;

export const CREATE_LINK_SHORTENER_DOMAIN_REQUEST = gql`
  ${DOMAIN_REQUEST_FIELDS}
  mutation createLinkShortenerDomainRequest(
    $input: CreateLinkShortenerDomainRequestInput!
  ) {
    createLinkShortenerDomainRequest(input: $input) {
      ...LinkShortenerDomainRequestFields
    }
  }
`;

export const DELETE_LINK_SHORTENER_DOMAIN_REQUEST = gql`
  mutation deleteLinkShortenerDomainRequest(
    $input: DeleteLinkShortenerDomainRequestInput!
  ) {
    deleteLinkShortenerDomainRequest(input: $input)
  }
`;
